import React from 'react';
import { BasicPageContainer } from "components/views/BasicPageContainer";
import { useTranslation } from 'react-i18next';

export const InvitationErrorPage = () => {
    const { t } = useTranslation();

    return <BasicPageContainer>
        <div>{t('invitationErrorPage.text')}</div>
    </BasicPageContainer>;
};